function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1260px;\n  height: ",
        "px;\n  // background-color: ",
        ";\n  // border-bottom: 1px solid ",
        ";\n  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, */\n  /* rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset; */\n  transform: translate3d(0, 0, 0);\n\n  margin: 0 auto;\n  padding: 0 16px;\n\n  > div:nth-child(2) {\n    > div:last-child {\n      > button {\n        font-size: 12px;\n        max-width: 80px;\n\n        ",
        " {\n          font-size: 14px;\n          max-width: 180px;\n        }\n\n        ",
        " {\n          width: 160px;\n        }\n\n        ",
        " {\n          font-size: 16px;\n        }\n      }\n    }\n\n    > button {\n      font-size: 12px;\n      max-width: 80px;\n\n      ",
        " {\n        font-size: 14px;\n        max-width: 180px;\n      }\n\n      ",
        " {\n        min-width: 160px;\n      }\n      ",
        " {\n        font-size: 16px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: ",
        ";\n  left: 0;\n  transition: top 0.2s;\n  height: ",
        ";\n  width: 100%;\n  z-index: 20;\n  background: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  > div > div:last-child {\n    transform: translate(-100%, 0);\n    background: radial-gradient(\n      108.15% 108.15% at 63.79% -8.15%,\n      rgba(53, 29, 78, 0.2) 0%,\n      rgba(233, 152, 198, 0.2) 100%\n    );\n    box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.25);\n    backdrop-filter: blur(25px);\n    border-radius: 8px 0px 0px 8px;\n\n    &::-webkit-scrollbar {\n      width: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #fff;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: rgba(204, 204, 204, 0.4);\n      border-radius: 100px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import throttle from "lodash/throttle";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { formatBigNumber } from "../../../../../src/utils/formatBalance";
import BottomNav from "../../components/BottomNav";
import { Box } from "../../components/Box";
import Flex from "../../components/Box/Flex";
import Footer from "../../components/Footer";
import MenuItems from "../../components/MenuItems/MenuItems";
import { SubMenuItems } from "../../components/SubMenuItems";
import { useMatchBreakpoints } from "../../hooks";
import Logo from "./components/Logo";
import { MENU_HEIGHT, MOBILE_MENU_HEIGHT, TOP_BANNER_HEIGHT, TOP_BANNER_HEIGHT_MOBILE } from "./config";
import LangSelector from "../../components/LangSelector/LangSelector";
import { MenuContext } from "./context";
import { Text } from "../../components/Text";
var Wrapper = styled.div.withConfig({
    componentId: "sc-7a24643c-0"
})(_templateObject());
var StyledNav = styled.nav.withConfig({
    componentId: "sc-7a24643c-1"
})(_templateObject1(), MENU_HEIGHT + 1, function(param) {
    var theme = param.theme;
    return theme.nav.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var FixedContainer = styled.div.withConfig({
    componentId: "sc-7a24643c-2"
})(_templateObject2(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? "0" : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var menuBackground = param.menuBackground;
    return menuBackground ? "#fff" : "transparent";
});
var TopBannerContainer = styled.div.withConfig({
    componentId: "sc-7a24643c-3"
})(_templateObject3(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-7a24643c-4"
})(_templateObject4());
var Inner = styled.div.withConfig({
    componentId: "sc-7a24643c-5"
})(_templateObject5());
var LangSelectorBox = styled(Box).withConfig({
    componentId: "sc-7a24643c-6"
})(_templateObject6());
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, banner = param.banner, rightSide = param.rightSide, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children, balance = param.balance, account = param.account, tokenPrice = param.tokenPrice;
    var ref;
    var ref1 = useMatchBreakpoints(), isMobile = ref1.isMobile, isTablet = ref1.isTablet;
    var ref2 = useState(true), showMenu = ref2[0], setShowMenu = ref2[1];
    var ref3 = useState(false), menuBackground = ref3[0], setMenuBackground = ref3[1];
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    var topBannerHeight = isMobile ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT;
    var totalTopMenuHeight = banner ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT;
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            // Always show the menu when user reach the top
            if (isTopOfPage) {
                setShowMenu(true);
                setMenuBackground(false);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    // Has scroll up
                    setShowMenu(true);
                    setMenuBackground(true);
                } else {
                    // Has scroll down
                    setShowMenu(false);
                    setMenuBackground(true);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight
    ]);
    // Find the home link if provided
    var homeLink = links.find(function(link) {
        return link.label === "Home";
    });
    var subLinksWithoutMobile = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return !subLink.isMobileOnly;
    });
    var subLinksMobileOnly = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return subLink.isMobileOnly;
    });
    var ref4;
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsxs(FixedContainer, {
                    showMenu: showMenu,
                    height: totalTopMenuHeight,
                    menuBackground: menuBackground,
                    children: [
                        banner && /*#__PURE__*/ _jsx(TopBannerContainer, {
                            height: topBannerHeight,
                            children: banner
                        }),
                        /*#__PURE__*/ _jsxs(StyledNav, {
                            children: [
                                /*#__PURE__*/ _jsxs(Flex, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Logo, {
                                            isDark: isDark,
                                            href: (ref4 = homeLink === null || homeLink === void 0 ? void 0 : homeLink.href) !== null && ref4 !== void 0 ? ref4 : "/"
                                        }),
                                        !isTablet && !isMobile && /*#__PURE__*/ _jsx(MenuItems, {
                                            items: links,
                                            activeItem: activeItem,
                                            activeSubItem: activeSubItem,
                                            ml: "28px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Flex, {
                                    alignItems: "center",
                                    height: "100%",
                                    children: [
                                        !isMobile && account && (balance === null || balance === void 0 ? void 0 : balance.fetchStatus) === "FETCHED" && /*#__PURE__*/ _jsxs(Flex, {
                                            mt: "4px",
                                            mr: "20px",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            children: [
                                                /*#__PURE__*/ _jsx(Flex, {
                                                    width: "32px",
                                                    height: "32px",
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    mr: "12px",
                                                    children: /*#__PURE__*/ _jsx("img", {
                                                        src: "/logo.png",
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs(Text, {
                                                    as: "p",
                                                    fontWeight: 500,
                                                    children: [
                                                        "$",
                                                        (ref = +formatBigNumber(balance === null || balance === void 0 ? void 0 : balance.balance, 3) * tokenPrice) === null || ref === void 0 ? void 0 : ref.toFixed(3)
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(LangSelectorBox, {
                                            mt: "4px",
                                            children: /*#__PURE__*/ _jsx(LangSelector, {
                                                currentLang: currentLang,
                                                langs: langs,
                                                setLang: setLang,
                                                buttonScale: "xs",
                                                color: "textSubtle",
                                                hideLanguage: true
                                            })
                                        }),
                                        rightSide
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!subLinks.length && /*#__PURE__*/ _jsxs(Flex, {
                    justifyContent: "space-around",
                    children: [
                        /*#__PURE__*/ _jsx(SubMenuItems, {
                            items: subLinksWithoutMobile,
                            mt: "".concat(totalTopMenuHeight + 1, "px"),
                            activeItem: activeSubItem
                        }),
                        (subLinksMobileOnly === null || subLinksMobileOnly === void 0 ? void 0 : subLinksMobileOnly.length) > 0 && /*#__PURE__*/ _jsx(SubMenuItems, {
                            items: subLinksMobileOnly,
                            mt: "".concat(totalTopMenuHeight + 1, "px"),
                            activeItem: activeSubItem,
                            isMobileOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(BodyWrapper, {
                    children: /*#__PURE__*/ _jsxs(Inner, {
                        isPushed: false,
                        showMenu: showMenu,
                        children: [
                            children,
                            /*#__PURE__*/ _jsx(Footer, {
                                isMobile: isMobile,
                                items: footerLinks,
                                isDark: isDark,
                                toggleTheme: toggleTheme,
                                langs: langs,
                                setLang: setLang,
                                currentLang: currentLang,
                                cakePriceUsd: cakePriceUsd,
                                buyCakeLabel: buyCakeLabel,
                                balance: balance,
                                account: account,
                                mb: [
                                    "".concat(MOBILE_MENU_HEIGHT, "px"),
                                    null,
                                    null,
                                    "".concat(MOBILE_MENU_HEIGHT, "px"),
                                    "0px"
                                ],
                                tokenPrice: tokenPrice
                            })
                        ]
                    })
                }),
                (isMobile || isTablet) && /*#__PURE__*/ _jsx(BottomNav, {
                    items: links,
                    activeItem: activeItem,
                    activeSubItem: activeSubItem
                })
            ]
        })
    });
};
export default Menu;
